// Realistic, on-theme Unsplash imagery (verified). All images relate to Argentina's
// natural-resource sectors: lithium salt flats, mining, oil & gas, analytics dashboards.
const U = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  heroMine: U('1571223641822-b82408a0e705', 1600), // aerial lithium brine mine (turquoise pools)
  miningTrucks: U('1517089152318-42ec560349c0', 1200), // aerial mining excavation / trucks
  refinery: U('1516937941344-00b4e0337589', 1200), // oil refinery / gas processing plant
  oilRig: U('1675060968918-2b7c543be938', 1200), // drilling rig
  dashboardDark: U('1551288049-bebda4e38f71', 1200), // dark analytics dashboard
  dashboardLaptop: U('1460925895917-afdab827c52f', 1200), // laptop analytics dashboard
  marketCandles: U('1611974789855-9c2a0a7236a3', 1200), // candlestick market chart
  marketScreen: U('1590283603385-17ffb3a7f29f', 1200), // trading screen
  wind: U('1466611653911-95081537e5b7', 1200), // wind turbines at sunset
  solarField: U('1508514177221-188b1cf16e9d', 1200), // solar panel field
  solarRoof: U('1613665813446-82a78c468a1d', 1200), // industrial solar roof
  collaboration: U('1454165804606-c3d57bc86b40', 1200), // business analysis / collaboration
};

export default IMAGES;
